export default __webpack_public_path__ + "static/media/Group 1.648302ed.png";